import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  layoutQueueHeader: {},
  layoutQueueToolbar: {
    margin: theme.spacing(0, 5, 2.5),
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(1, 2, 2)
    }
  },
  layoutQueueContent: {
    display: "contents"
  },
  layoutQueueBody: {
    display: "flex",
    width: "100%",
    flex: 1,
    position: "relative",
    flexDirection: "column",
    overflowY: "hidden"
  },
  layoutQueueFooter: {}
}));
const LayoutQueue = ({ header, toolbar, body, footer, dataTestId }) => {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, header ? /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueHeader }, header) : null, toolbar || body ? /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueContent, "data-testid": dataTestId }, toolbar ? /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueToolbar }, toolbar) : null, body ? /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueBody }, body) : null) : null, footer ? /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueFooter }, footer) : null);
};
export {
  LayoutQueue
};
//# sourceMappingURL=LayoutQueue.js.map
